// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Libs
import { cn } from '@/common-utils/libraries/tailwind/utils';
// Components
import TooltipHelper from '../tooltip/TooltipHelper';
import PopoverHelper from '../popover/PopoverHelper';
import Icon from '../icon/Icon';
import Entity from '../entity/Entity';
// Common
import useCanHover from '@/common-utils/hooks/useCanHover';

/**
 * @param {Object} props
 * @param {string} props.icon
 * @param {string} props.tooltipEntity
 * @param {string} props.namespace
 * @param {JSX} props.content
 * @returns {JSX} IconTooltip
 */
function IconTooltip({ icon, tooltipEntity, namespace, content = null }) {
    // Hooks
    const canHover = useCanHover();

    // State
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    return (
        <>
            {canHover ? (
                <TooltipHelper
                    content={content || <Entity entity={tooltipEntity} namespace={namespace} className='text-sm' />}
                    trigger={<Icon icon={icon} />}
                />
            ) : (
                <PopoverHelper
                    isOpen={isTooltipOpen}
                    onOpenChange={setIsTooltipOpen}
                    trigger={<Icon icon={icon} />}
                    content={content || <Entity entity={tooltipEntity} namespace={namespace} className='text-sm' />}
                    contentClass={cn('p-2 mr-2', content ? 'w-auto' : 'max-w-52')}
                />
            )}
        </>
    );
}

IconTooltip.propTypes = {
    icon: PropTypes.string.isRequired,
    tooltipEntity: PropTypes.string,
    namespace: PropTypes.string,
    content: PropTypes.element
};

export default IconTooltip;